import nBossConnection from 'modules/base/service/nBossConnection';

class UserLoginService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'userLogin';
	}

	/**
	 * @return {Promise<Object|null>}
	 */
	getLoginState() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getLoginState`)
				.then(response => resolve(response?.data ?? null))
				.catch(reject);
		});
	}

	/**
	 * @param {string} email
	 * @param {string} password
	 * @return {Promise<Object|boolean>}
	 */
	login(email, password) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/login`, {
					email,
					password
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {string} role
	 * @return {Promise<Object|boolean>}
	 */
	setRole(role) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/setRole`, { role })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} userGroupId
	 * @return {Promise<Object|boolean>}
	 */
	setUserGroupId(userGroupId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/setUserGroupId`, { userGroupId })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {string} role
	 * @return {Promise<Object|boolean>}
	 */
	changeRole(role) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/changeRole`, { role })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<any>}
	 */
	logout() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/logout`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<boolean>}
	 */
	isLoggedIn() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/isLoggedIn`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new UserLoginService();
